// extracted by mini-css-extract-plugin
export var fullHeightState = "_5k-7";
export var headerCell = "_5k-1";
export var loadingStateCell = "_5k-4";
export var rowWrapper = "_5k-3";
export var standaloneTable = "_5k-8";
export var standaloneTableWithBodyFill = "_5k-9";
export var stateCell = "_5k-5";
export var table = "_5k-0";
export var tableBodyFiller = "_5k-6";
export var white = "_5k-2";